import { api } from '../../../index';
import { GetAllPlanLabels } from '../../types/usePlanLabels.types';

export const getAllPlanLabels = async (): Promise<GetAllPlanLabels> => {
  return await api.get<GetAllPlanLabels>('/onboarding/plan-labels');
};
